import sortBy from 'lodash/fp/sortBy';

const sortByCreatedAt = sortBy(['createdAt']);

/**
 * Include id into the object
 * @param child
 * @returns {Object}
 */
export function serializeItem(child) {
	return {
		...child.val(),
		id: child.key
	};
}

/**
 * We would like to preserve the order in the arrays
 * @param snapshot
 * @returns {Array}
 */
export function serializeList(snapshot) {
	const resources = [];

	snapshot.forEach(child => {
		resources.push(serializeItem(child));
	});

	return sortByCreatedAt(resources);
}



// WEBPACK FOOTER //
// ./src/client/redux/actions/helpers/serializers.js